import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown, X, Menu } from 'lucide-react';
export function Navigation() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isActive = (path: string) => location.pathname === path;
  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };
  return <>
      {/* Desktop Navigation */}
      <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-600 ml-auto font-sans" data-id="element-1056">
        {/* Solutions Dropdown */}
        <div className="relative group" data-id="element-1057">
          <button className="flex items-center gap-1 hover:text-black transition-colors py-2" data-id="element-1058">
            Solutions
            <ChevronDown className="w-4 h-4 transition-transform group-hover:rotate-180" data-id="element-1059" />
          </button>

          {/* Dropdown Menu */}
          <div className="absolute top-full left-0 pt-2 w-56 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 transform group-hover:translate-y-0 translate-y-2 z-50" data-id="element-1060">
            <div className="bg-white border border-gray-100 shadow-xl rounded-lg overflow-hidden p-1" data-id="element-1061">
              <Link to="/the-instruction-layer" className={`block px-4 py-3 text-sm rounded-md transition-colors ${isActive('/the-instruction-layer') ? 'font-bold text-[#0066FF] bg-blue-50' : 'text-gray-600 hover:text-black hover:bg-gray-50'}`} data-id="element-1062">
                The Instruction Layer
              </Link>
              <Link to="/context-engineering" className={`block px-4 py-3 text-sm rounded-md transition-colors ${isActive('/context-engineering') ? 'font-bold text-[#0066FF] bg-blue-50' : 'text-gray-600 hover:text-black hover:bg-gray-50'}`} data-id="element-1063">
                Context Engineering
              </Link>
              <Link to="/how-it-works" className={`block px-4 py-3 text-sm rounded-md transition-colors ${isActive('/how-it-works') ? 'font-bold text-[#0066FF] bg-blue-50' : 'text-gray-600 hover:text-black hover:bg-gray-50'}`} data-id="element-1064">
                How It Works
              </Link>
              <Link to="/agent-drift" className={`block px-4 py-3 text-sm rounded-md transition-colors ${isActive('/agent-drift') ? 'font-bold text-[#0066FF] bg-blue-50' : 'text-gray-600 hover:text-black hover:bg-gray-50'}`} data-id="element-1065">
                Agent Governance
              </Link>
            </div>
          </div>
        </div>

        <Link to="/about" className={`transition-colors ${isActive('/about') ? 'font-bold text-black' : 'hover:text-black'}`} data-id="element-1066">
          About Synthia
        </Link>
        <Link to="/pricing" className={`transition-colors ${isActive('/pricing') ? 'font-bold text-black' : 'hover:text-black'}`} data-id="element-1067">
          Pricing
        </Link>
        <Link to="/blog" className={`transition-colors ${isActive('/blog') ? 'font-bold text-black' : 'hover:text-black'}`} data-id="element-1068">
          Blog
        </Link>
        <Link to="/contact" className={`transition-colors ${isActive('/contact') ? 'font-bold text-black' : 'hover:text-black'}`} data-id="element-1069">
          Contact Us
        </Link>
        <a href="https://app.meetsynthia.ai" className="bg-black text-white px-6 py-2.5 font-['Syne'] font-bold text-xs tracking-wide hover:bg-[#0066FF] transition-colors" data-id="element-1070">
          SIGN IN
        </a>
      </nav>

      {/* Mobile Menu Button */}
      <button onClick={() => setMobileMenuOpen(true)} className="md:hidden ml-auto p-2 text-gray-600 hover:text-black transition-colors" aria-label="Open menu" data-id="element-1071">
        <Menu className="w-6 h-6" data-id="element-1072" />
      </button>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && <>
          {/* Backdrop */}
          <div className="fixed inset-0 bg-black/50 z-[90] md:hidden" onClick={closeMobileMenu} data-id="element-1073" />

          {/* Menu Drawer */}
          <div className="fixed top-0 right-0 bottom-0 w-[85%] max-w-sm bg-white z-[100] md:hidden shadow-2xl overflow-y-auto" data-id="element-1074">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-1075">
              <span className="text-lg font-bold font-['Syne']" data-id="element-1076">Menu</span>
              <button onClick={closeMobileMenu} className="p-2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Close menu" data-id="element-1077">
                <X className="w-6 h-6" data-id="element-1078" />
              </button>
            </div>

            {/* Navigation Links */}
            <nav className="p-6 space-y-1" data-id="element-1079">
              {/* Solutions Section */}
              <div className="mb-6" data-id="element-1080">
                <div className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3 px-4" data-id="element-1081">
                  Solutions
                </div>
                <Link to="/the-instruction-layer" onClick={closeMobileMenu} className={`block px-4 py-3 rounded-lg text-base transition-colors ${isActive('/the-instruction-layer') ? 'font-bold text-[#0066FF] bg-blue-50' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-1082">
                  The Instruction Layer
                </Link>
                <Link to="/context-engineering" onClick={closeMobileMenu} className={`block px-4 py-3 rounded-lg text-base transition-colors ${isActive('/context-engineering') ? 'font-bold text-[#0066FF] bg-blue-50' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-1083">
                  Context Engineering
                </Link>
                <Link to="/how-it-works" onClick={closeMobileMenu} className={`block px-4 py-3 rounded-lg text-base transition-colors ${isActive('/how-it-works') ? 'font-bold text-[#0066FF] bg-blue-50' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-1084">
                  How It Works
                </Link>
                <Link to="/agent-drift" onClick={closeMobileMenu} className={`block px-4 py-3 rounded-lg text-base transition-colors ${isActive('/agent-drift') ? 'font-bold text-[#0066FF] bg-blue-50' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-1085">
                  Agent Governance
                </Link>
              </div>

              {/* Other Links */}
              <Link to="/about" onClick={closeMobileMenu} className={`block px-4 py-3 rounded-lg text-base transition-colors ${isActive('/about') ? 'font-bold text-[#0066FF] bg-blue-50' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-1086">
                About Synthia
              </Link>
              <Link to="/pricing" onClick={closeMobileMenu} className={`block px-4 py-3 rounded-lg text-base transition-colors ${isActive('/pricing') ? 'font-bold text-[#0066FF] bg-blue-50' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-1087">
                Pricing
              </Link>
              <Link to="/blog" onClick={closeMobileMenu} className={`block px-4 py-3 rounded-lg text-base transition-colors ${isActive('/blog') ? 'font-bold text-[#0066FF] bg-blue-50' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-1088">
                Blog
              </Link>
              <Link to="/contact" onClick={closeMobileMenu} className={`block px-4 py-3 rounded-lg text-base transition-colors ${isActive('/contact') ? 'font-bold text-[#0066FF] bg-blue-50' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-1089">
                Contact Us
              </Link>

              {/* Sign In Button - Mobile */}
              <div className="pt-4 mt-4 border-t border-gray-100" data-id="element-1090">
                <a href="https://app.meetsynthia.ai" className="block text-center bg-black text-white px-6 py-3 font-['Syne'] font-bold text-sm tracking-wide hover:bg-[#0066FF] transition-colors rounded-lg" data-id="element-1091">
                  SIGN IN
                </a>
              </div>
            </nav>
          </div>
        </>}
    </>;
}